// src/components/common/AppHeader.js
// 78차 63차: 웹에서 "‹"/"뒤로"의 fontSize·lineHeight 차이로 두 글리프가 서로 다른
// 높이에 그려지던 버그 수정(크기를 낮추고 lineHeight를 맞춤).
// 전체 앱 공통 헤더 — 일반/매장관리자/총관리자 모두 동일 ESCAPE ROOM 로고
// 50차: showBack 시 ‹ 뒤로 텍스트 추가
// 51차: 색/폰트 theme.js 단일화 — 하드코딩 색·'serif' 제거, COLORS·FONTS 참조
// 72차: 로고 워드마크에 FONTS.brand(Space Grotesk, 라틴 전용) 적용 — "UNLOCK"은
// 순수 영문이라 안전. 커스텀 폰트 파일 자체가 이미 특정 굵기라 fontWeight를 같이
// 주면 안드로이드에서 폰트 매칭이 꼬일 수 있어 제거.
// 73차: claude.ai/design "UNLOCK 디자인" 로고 시안 1a(Keyhole Maze) 적용 —
// 이모지 🔐 대신 실제 심볼(둥근 사각 링 + 열쇠구멍)을 react-native-svg로 그리고,
// 워드마크 색도 골드 → 크림(COLORS.text)으로 — 디자인 원본은 심볼만 골드, 텍스트는 크림.
// 75차: 로고 심볼/워드마크가 작다는 피드백으로 크기 확대(심볼 22→28, 텍스트 18→21).
// 75차: design_handoff_unlock 핸드오프 반영 — 이중 링 버전 적용했었으나, 사용자가 74차
// 버전(바깥 링만)으로 원복 요청 — 아래 LogoMark를 74차 사양으로 되돌림(크기는 28 유지).
// 77차: design 폴더(design_handoff_unlock) 로고 섹션(1a "Keyhole Frame") 최종 재적용 —
// 사용자가 "design 파일을 참고해 로고 디자인 바꿔달라"고 재요청, 75차의 원복 결정을 덮어씀.
// 바깥 링(골드 그라디언트, stroke-width 2.8) + 이너 링(stroke-width 2.6, opacity .72) 복원.
// 75차: 비회원이 보는 화면(Home/Booking/Crew 등)에서 각 화면이 rightElement를 안 넘기면
// 자동으로 "로그인/회원가입" 링크를 보여줌 — 하단 탭에서 로그인 전용 탭을 없앤 대신
// (navigation/index.js) 여기서 진입 경로를 대신 제공.
// 76차: LogoMark export — SplashLoadingScreen.js가 재사용(로딩 화면이 네이티브 스플래시와
// 시각적으로 이어지도록 같은 로고를 씀).
// 76차: onBackPress prop 추가(선택) — BookingDetailScreen.js/StoreDetailScreen.js 등
// 화면 내부 "스텝"을 되돌리는 용도로 뒤로가기를 쓰는 곳이 있어, 기본값(navigation.goBack())을
// 덮어쓸 수 있게 함. 안 넘기면 기존과 동일하게 동작(하위 호환).
// 78차 32차: 뒤로가기 터치 영역이 헤더 우측 빈 공간까지 넓게 잡히던 버그 수정 —
// `left`가 `flex:1`인데 그 안의 `backBtn`(TouchableOpacity)엔 정렬 지정이 없어서 RN
// 기본값(column 컨테이너의 alignItems:'stretch')대로 `left`가 늘어난 너비를 그대로
// 채워버리고 있었음 — rightElement가 없는 화면(마이탭 하위 다수)일수록 `left`가 헤더
// 폭 대부분을 차지해, 아무 것도 안 보이는 우측 빈 공간을 눌러도 뒤로가기가 되는 걸로
// 나타남. backBtn에 alignSelf:'flex-start'를 줘서 실제 내용(‹ 뒤로) 크기만큼만
// 터치되도록 수정.
// 같은 라운드: 로고 워드마크가 작아 가독성이 떨어진다는 피드백으로 크기 확대
// (심볼 28→32/글자 21→24, showBack 축소판도 16→18/15→17).
// 78차 37차: 중앙 로고/타이틀이 우측 "로그인/회원가입" 버튼 대비 작아 보인다는 피드백으로
// 한 번 더 확대(심볼 32→38/글자 24→28, showBack 축소판 20→24/18→21).

import React from 'react';
import { View, Text, StyleSheet, TouchableOpacity } from 'react-native';
import Svg, { Rect, Circle, Path, Defs, LinearGradient, Stop } from 'react-native-svg';
import { useNavigation } from '@react-navigation/native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { useAuth } from '../../contexts/AuthContext';
import { AdminIcon, MenuStoreIcon } from './Icons';
import { SecondaryButton } from './Buttons';
import { COLORS, FONTS } from '../../constants/theme';

// 74차 사양 — 바깥 링(rx24, stroke-width 9) + 중앙 열쇠구멍(원+사다리꼴 스템)만
// 76차: SplashLoadingScreen.js에서도 재사용하기 위해 export
export function LogoMark({ size = 26 }) {
  return (
    <Svg width={size} height={size} viewBox="0 0 100 100" fill="none">
      <Defs>
        <LinearGradient id="logoGrad" x1="0" y1="0" x2="1" y2="1">
          <Stop offset="0" stopColor={COLORS.goldPale} />
          <Stop offset="0.5" stopColor={COLORS.gold} />
          <Stop offset="1" stopColor={COLORS.goldDark} />
        </LinearGradient>
      </Defs>
      <Rect x="14" y="14" width="72" height="72" rx="20" stroke="url(#logoGrad)" strokeWidth="2.8" />
      <Rect x="30" y="30" width="40" height="40" rx="12" stroke={COLORS.gold} strokeWidth="2.6" strokeOpacity="0.72" />
      <Circle cx="50" cy="44" r="6.6" fill={COLORS.goldLight} />
      <Path d="M47.6 49 L45.6 62 H54.4 L52.4 49 Z" fill={COLORS.goldLight} />
    </Svg>
  );
}

export default function AppHeader({ showBack = false, centerElement, rightElement, isModal = false, onBackPress }) {
  const navigation = useNavigation();
  const insets = useSafeAreaInsets();
  const { isLoggedIn } = useAuth();
  const topPad = isModal ? 0 : insets.top;
  // 78차: showBack인데 화면이 centerElement(제목)를 안 넘기면 "‹ 뒤로"만 있는 빈
  // 헤더가 됨 — 화면마다 제목을 챙기게 하는 대신 여기서 기본값(작은 로고+UNLOCK)을
  // 채워 재발을 원천 차단(RecruitDetailScreen/ThemeDetailScreen/EditProfileScreen 등).
  // 78차 후속: 위 폴백은 centerElement가 "아예 없을 때만" 동작해서, 뒤로가기+제목이 있는
  // 화면("예약 내역" 등 대다수 서브 화면)은 여전히 로고가 전혀 안 보였음 — 사용자가
  // 스크린샷 두 장으로 반복 확인한 실제 신고 내용. showBack이면 제목 유무와 무관하게
  // 항상 작은 로고 마크를 제목 앞에 붙여서, 뒤로가기가 있는 모든 화면에서 브랜드가
  // 보이도록 함(제목이 있으면 "🔐 제목", 없으면 "🔐 UNLOCK").
  const center = showBack ? (
    <View style={s.logoRowSmall}>
      <LogoMark size={24} />
      {centerElement || <Text style={s.logoSmall}>UNLOCK</Text>}
    </View>
  ) : centerElement;
  return (
    <View style={[s.wrap, { paddingTop: topPad }]}>
      <View style={s.inner}>
        <View style={s.left}>
          {showBack ? (
            <TouchableOpacity
              style={s.backBtn}
              onPress={() => (onBackPress ? onBackPress() : navigation.goBack())}
              hitSlop={{ top: 10, bottom: 10, left: 10, right: 10 }}>
              <Text style={s.backArrow}>‹</Text>
              <Text style={s.backText}>뒤로</Text>
            </TouchableOpacity>
          ) : centerElement ? null : (
            <View style={s.logoRow}>
              <LogoMark size={38} />
              <Text style={s.logo}>UNLOCK</Text>
            </View>
          )}
        </View>
        {center ? <View style={s.center}>{center}</View> : null}
        <View style={s.right}>
          {rightElement || (!isLoggedIn && (
            <SecondaryButton label="로그인 / 회원가입" onPress={() => navigation.navigate('Login')} style={s.loginBtn} textStyle={s.loginBtnText} />
          )) || null}
        </View>
      </View>
      <View style={s.goldLine} />
    </View>
  );
}

export function RoleBadge({ role }) {
  if (!role) return null;
  const map = {
    super: { label: '총관리자',   Icon: AdminIcon,     bg: COLORS.goldBgLight, border: COLORS.gold,    color: COLORS.gold },
    store: { label: '매장관리자', Icon: MenuStoreIcon, bg: COLORS.warningBg,   border: COLORS.warning, color: COLORS.warning },
  };
  const cfg = map[role];
  if (!cfg) return null;
  return (
    <View style={[badge.wrap, { backgroundColor: cfg.bg, borderColor: cfg.border, flexDirection: 'row', alignItems: 'center', gap: 5 }]}>
      <cfg.Icon size={12} color={cfg.color} />
      <Text style={[badge.txt, { color: cfg.color }]}>{cfg.label}</Text>
    </View>
  );
}

const badge = StyleSheet.create({
  wrap: { borderRadius: 20, paddingHorizontal: 10, paddingVertical: 4, borderWidth: 1 },
  txt:  { fontSize: 11, fontWeight: '700' },
});

const s = StyleSheet.create({
  wrap: {
    backgroundColor: COLORS.surface,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.4,
    shadowRadius: 6,
    elevation: 6,
    zIndex: 100,
  },
  inner: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 16,
    paddingVertical: 10,
    minHeight: 50,
    justifyContent: 'space-between',
  },
  goldLine: {
    height: 2,
    backgroundColor: COLORS.gold,
  },
  left:  { flex: 1 },
  // 78차 35차: center가 헤더 전체 폭에 절대위치로 겹쳐 있어(rightElement 폭과 무관하게
  // 항상 화면 정중앙) 오른쪽 버튼이 여러 개인 화면(RecruitDetailScreen의 노출/수정/삭제
  // 등)에서 제목 텍스트와 버튼이 그대로 겹쳐 보이는 문제 발견 — flex 기반 3분할로 교체.
  // left/right를 동일한 flex:1로 맞춰 center가 실제 남은 공간 한가운데 자연스럽게 배치되고,
  // 버튼이 많아 right가 넓어지면 center가 자동으로 좁아지며 절대 겹치지 않음. 좌우가
  // 짧은 기존 화면들(로그인 버튼 하나 등)은 시각적으로 변화 없음.
  center:{ flex: 1, alignItems: 'center' },
  right: { flex: 1, alignItems: 'flex-end' },
  logoRow: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
  },
  logo: {
    fontSize: 28,
    color: COLORS.text,
    letterSpacing: 4,
    fontFamily: FONTS.brand,
  },
  logoRowSmall: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 6,
  },
  logoSmall: {
    fontSize: 21,
    color: COLORS.text,
    letterSpacing: 2,
    fontFamily: FONTS.brand,
  },
  backBtn: {
    flexDirection: 'row',
    alignItems: 'center',
    alignSelf: 'flex-start',
    gap: 4,
  },
  // 78차 63차: 웹에서 "‹" 글리프가 폰트 em box 위쪽에 그려져(폰트마다 다름) 30px 크기로
  // 키워두면 옆 "뒤로" 텍스트 기준선보다 눈에 띄게 높게 보이던 버그 — 부모(backBtn)의
  // alignItems:'center'는 각 자식의 line box 높이를 기준으로 정렬해서, 두 요소의
  // fontSize/lineHeight 차이가 크면 글리프 잉크 위치까지는 못 맞춰줌. 크기를 낮추고
  // lineHeight를 backText와 맞춰 같은 line box 안에서 정렬되도록 수정.
  backArrow: {
    fontSize: 20,
    color: COLORS.gold,
    lineHeight: 20,
    fontWeight: '600',
  },
  backText: {
    fontSize: 14,
    lineHeight: 20,
    color: COLORS.gold,
    fontWeight: '600',
  },
  loginBtn: { paddingHorizontal: 10, paddingVertical: 6 },
  loginBtnText: { fontSize: 12 },
});